// Public profile pin order is editorial data; an invalid snapshot must not expand the selection.
export function selectPinnedSketches(selection, catalog) {
  if (selection?.status !== 'verified' || selection.sourceUrl !== 'https://openprocessing.org/user/139364') throw new Error('Unverified OpenProcessing selection source')
  if (!Array.isArray(selection.ids) || !selection.ids.length) throw new Error('Empty pinned sketch selection')
  if (new Set(selection.ids).size !== selection.ids.length) throw new Error('Duplicate pinned sketch ID')
  const byId = new Map(catalog.map(sketch => [sketch.id, sketch]))
  return selection.ids.map(id => {
    if (typeof id !== 'string' || !byId.has(id)) throw new Error('Unknown pinned sketch ID: ' + id)
    return byId.get(id)
  })
}
